/**
 * Creates a class-set with BEM modifiers for a component
 * @param {string} prefix Prefix classname for the component
 * @param {Array} modifier Array with modifiers
 * @return {string} Classnames in BEM format
 */
export default function withModifier(prefix, modifier) {
  const flattenArray = (arr) => {
    return arr.reduce((acc, val) => (Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val)), []);
  };

  let classes = [prefix];
  const modifiers = flattenArray(modifier || []);

  const uniqueModifiers = modifiers.filter((m, i) => {
    return modifiers.indexOf(m) === i;
  });

  classes = [...classes, ...uniqueModifiers.filter((suffix) => suffix).map((suffix) => `${prefix}--${suffix}`)];

  return classes.join(' ');
}
